import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector, useAppDispatch } from '../../../../redux/hooks';

// Components 

import Box from '@mui/material/Box';
import ListItemIcon from '@mui/material/ListItemIcon';
import { setIsSidebarOpened, setSidebarSection } from '../../../../redux/features/doctor/Dashboard/consultation/consultationNote';

type Props = {
    children?: React.ReactNode,
    title: string, 
    section: string, 
  };


const NavigationItem: React.FC<Props> = ({ children, title, section }) => {

    const dispatch = useAppDispatch(); 

    const { t } = useTranslation(); 

    const colors = useAppSelector(state => state.theme.colors);
    const sidebarSection = useAppSelector(state => state.consultationNote.sidebarSection); 

    // -- 

    const changeSection = () => { 

        if (section) { 

            dispatch(setSidebarSection(section)); 
            dispatch(setIsSidebarOpened(true)); 

        };

    }; 

    // -- 

    return (

        <Box
          onClick={changeSection} 
          sx={{ 
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center', 
            width: '75%', 
            height: 100,
            borderTopLeftRadius: '30%',
            borderBottomLeftRadius: '30%',
            cursor: 'pointer',
            color: section === sidebarSection ? colors?.selectedSideBarItem : 'transparent',
          }}
        >

            <ListItemIcon 
                sx={{ 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center', 
                justifyContent: 'space-evenly', 
                borderRadius: 4,
                paddingTop: 1,
                paddingBottom: 1,
                marginBottom: 0.3,
                fontSize: 35, 
                color: section === sidebarSection ? colors?.selectedSideBarItem : colors?.sidebarUnselectedItem,
                '&:hover': { backgroundColor: colors?.templateSidebarItemHover}}
                }>
                  {children}
            </ListItemIcon>


          <Box
            sx={{ 
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center', 
              justifyContent: 'space-evenly', 
              width: '100%', 
              fontSize: 10,
              color: section === sidebarSection ? colors?.highlightedText : colors?.text
            }}
          >{t(title)}</Box>

        </Box>

    );

};

export default NavigationItem;